// extracted by mini-css-extract-plugin
export default {"textLoader":"text-loader_textLoader__Fu3Y6"};